import Trip from '@models/Trip';

export default {
  components: {
    LocationField: () => import('@components/utilities/LocationField'),
  },
  data() {
    return {
      trips: [],
    };
  },
  methods: {
    async getTrips() {
      let tripModal = new Trip();
      let response = await tripModal.get();
      this.trips = this.trips.concat(response.data);
    },
    toggleTrip(id) {
      let index = this.request.business.trip_ids.findIndex(
        (tripID) => tripID === id
      );
      if (index > -1) {
        this.request.business.trip_ids.splice(index, 1);
      } else {
        this.request.business.trip_ids.push(id);
      }
    },
  },
};
